// extracted by css-extract-rspack-plugin
export default {"choiceList":"choiceList-K0GQIy","choice":"choice-NOOuAi"};